angular.module('mtic')
  .constant('BRANDING', {
    "MTIC": {
      'code': 'mtic',
      'clazz': 'mtic-branding'
    },
    "OCMT": {
      'code': 'ocmt',
      'clazz': 'ocmt-branding'
    }
  })
